// src/pages/MainNavbar.js
import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import '../App.css';
import defaultLogo from '../assets/data/logo.png';

const MainNavbar = ({ logoSrc }) => {
  const location = useLocation();
  const isActive = (prefix) => location.pathname.startsWith(prefix);
  const src = logoSrc || defaultLogo;

  return (
    <Navbar expand="lg" className="kkr-navbar" variant="light">
      <div className="navbar-inner">
        {/* Toggle first so it stays on the left on mobile */}
        <Navbar.Toggle aria-controls="main-navbar-nav" />

        {/* LEFT: links (fill row) */}
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="main-nav-links">
            <Nav.Link
              as={Link}
              to="/ueberblick/hintergrund"
              className={isActive('/ueberblick') ? 'nav-link active' : 'nav-link'}
            >
              Überblick
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/methodik/datengrundlage"
              className={isActive('/methodik') ? 'nav-link active' : 'nav-link'}
            >
              Methodik
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/krebsgesamt/zeitverlauf"
              className={isActive('/krebsgesamt') ? 'nav-link active' : 'nav-link'}
            >
              Krebs-Häufigkeiten
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/entit/altersverteilung"
              className={isActive('/entit') ? 'nav-link active' : 'nav-link'}
            >
              Klinik und Follow-up
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

        {/* RIGHT: logo */}
        <div className="brand">
          <img src={src} alt="Krebsregister Sachsen-Anhalt" className="logo" />
        </div>
      </div>
    </Navbar>
  );
};

export default MainNavbar;

